// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__rjR2K","wrapper":"modal_wrapper__MnXf9"};